const clickSequence = (state = 1, action) => {
    switch (action.type) {
        case "INCREMENT_CLICK_SEQUENCE":
            return state + 1;

        case "RESET_CLICK_SEQUENCE":
            return 1;

        default:
            return state;
    }
};

export default clickSequence;



// WEBPACK FOOTER //
// ./src/reducers/clickSequence.js